import React from 'react';
import { useOutletContext, useParams } from 'react-router-dom';

import {
  calloutSessionIdConfig,
  inputAcceptTransmitDataConfig,
  inputBirthcountryConfig,
  inputBirthdateConfig,
  inputBirthplaceConfig,
  inputEmailConfig,
  inputEmailValidConfig,
  inputFileUploadConfig,
  inputPhoneConfig,
  inputSessionIdConfig,
  inputTextareaDescriptionConfig,
} from '../../../configs';
import { fraudFormValues, PageLayoutContext } from '../../../interfaces';
import { personGroupDecorator } from '../../../libs/decorators';
import { FileInputLabel, FormName, FormType } from '../../../libs/enums';
import {
  CalloutComponent,
  CheckboxComponent,
  FileUploadComponent,
  TextAreaComponent,
  TextInputComponent,
} from '../../dsfr';
import { FormWrapperComponent } from '../form-wrapper';
import { PersonGroup } from '../person-group';

interface RouteParams extends Record<string, string | undefined> {
  fraudSurveyOrigin: string;
}

export const FraudForm = React.memo(() => {
  const { fraudSurveyOrigin } = useParams<RouteParams>();
  const { errorId, platform } = useOutletContext<PageLayoutContext>();

  const memoizedDescription = React.useMemo(
    () => (
      <React.Fragment>
        Pour faciliter la prise en charge de votre demande, veuillez nous transmettre la capture
        d’écran de la notification de connexion reçue.
        <br />
        <br />
        Taille maximale : 2Mo. Les formats supportés sont : JPG, JPEG, PNG, GIF, DOCX, ODT, PDF.
      </React.Fragment>
    ),
    [],
  );

  return (
    <FormWrapperComponent<fraudFormValues>
      decorators={[personGroupDecorator]}
      initialValues={{
        acceptTransmitData: false,
        birthcountry: undefined,
        birthdate: undefined,
        birthplace: undefined,
        email: undefined,
        emailValid: undefined,
        errorId,
        firstName: undefined,
        firstNameDisabled: false,
        formName: FormName.FRAUD,
        formType: FormType.FRAUD,
        fraudSurveyOrigin,
        lastName: undefined,
        lastNameDisabled: false,
        phone: undefined,
        platform,
        sessionId: undefined,
      }}
      title="Signalez une usurpation d’identité">
      <React.Fragment>
        <PersonGroup />
        <TextInputComponent {...inputBirthdateConfig} />
        <TextInputComponent {...inputBirthcountryConfig} />
        <TextInputComponent {...inputBirthplaceConfig} />
        <TextInputComponent {...inputEmailConfig} />
        <TextInputComponent {...inputEmailValidConfig} />
        <TextInputComponent {...inputPhoneConfig} />
        <TextAreaComponent {...inputTextareaDescriptionConfig} />
        <FileUploadComponent
          {...inputFileUploadConfig}
          description={memoizedDescription}
          label={FileInputLabel.SCREEN}
          required={false}
        />
        <TextInputComponent {...inputSessionIdConfig} />
        <CalloutComponent {...calloutSessionIdConfig} />
        <CheckboxComponent {...inputAcceptTransmitDataConfig} />
      </React.Fragment>
    </FormWrapperComponent>
  );
});

FraudForm.displayName = 'FraudForm';
